import { Link } from "react-router-dom";
import styles from "./RelatedPost.module.css";

export default function RelatedPost({
  posts = [],
  basePath = "/blog",
  eyebrow = "More Reads",
  title = "Related Posts",
}) {
  const relatedPosts = posts.slice(0, 4);

  if (relatedPosts.length === 0) {
    return null;
  }

  return (
    <aside className={styles.sidebar}>
      <div className={styles.header}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h3>{title}</h3>
      </div>

      <div className={styles.list}>
        {relatedPosts.map((post) => (
          <Link key={post.slug} to={`${basePath}/${post.slug}`} className={styles.item}>
            {post.image ? (
              <img src={post.image} alt={post.title} className={styles.image} />
            ) : (
              <div className={styles.imageFallback}>PSP</div>
            )}

            <span className={styles.content}>
              <span className={styles.title}>{post.title}</span>
              <span className={styles.date}>{post.postedOn}</span>
            </span>
          </Link>
        ))}
      </div>
    </aside>
  );
}
